import React, { useRef } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import styles from './BoxStudent.module.css';
import BoxButton from '../../BoxButton/BoxButton';
import loader from '../../../images/loader.gif';

const BoxStudent = ({ properties, index, showStudent }) => {
  const node = useRef();
  const secondNode = useRef();

  const data = properties;
  const showUndoLink = data.attributes.showUndoLink
    || (data.attributes.assigned_photos_count !== null && data.attributes.assigned_photos_count > 0);
  const processed = data.attributes.event_processed_at !== null;

  const isNodeDefined = n => n.current !== undefined && n.current !== null;

  const showStudentConditionally = (e) => {
    if (
      (isNodeDefined(node) && node.current.contains(e.target))
      || (isNodeDefined(secondNode) && secondNode.current.contains(e.target))
    ) {
      return;
    }

    showStudent(data.id);
  };

  return (
    <Draggable key={`student-${data.id}`} draggableId={`student-${data.id}`} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={data.isStudentBoxMoving ? 'movable' : 'unmovable'}
          onClick={e => showStudentConditionally(e)}
        >
          <div className={`${styles.boxStudent} box`} id={data.id}>
            <div className={styles.boxStudentData}>
              {showUndoLink && (
                <span className="undo" onClick={() => data.undoUpdate(data.id)} ref={secondNode}>
                  undo photos assignment
                </span>
              )}
              {data.isLoadingAssignment && data.id === data.boxOfAssignment && (
                <img src={loader} alt="" className="loader" />
              )}
              <strong className={styles.name}>
                {data.attributes.first_name}
                <br />
                {data.attributes.last_name}
              </strong>
            </div>
            <BoxButton
              icon="fas fa-check fa-lg"
              handleClick={() => data.handleClick(data.id)}
              processed={processed}
              node={node}
            />
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default BoxStudent;



// WEBPACK FOOTER //
// ./src/components/ContentBox/BoxStudent/BoxStudent.js